type ImportMetaEnvValue = string | boolean | undefined;
type ImportMetaEnvLike = Record<string, ImportMetaEnvValue>;

const SHARED_UI_ENV_KEYS = [
  'VITE_IDP_BASE_URL',
  'VITE_MESSAGING_BASE_URL',
  'VITE_TEE_TIME_BASE_URL',
  'VITE_TEE_TIME_PUBLIC_TENANT_ID',
] as const;

type SharedUiEnvKey = (typeof SHARED_UI_ENV_KEYS)[number];

type GlobalWithImportMetaEnv = typeof globalThis & {
  importMetaEnv?: Partial<Record<SharedUiEnvKey, string>>;
};

export const installImportMetaEnvBridge = (env: ImportMetaEnvLike): void => {
  const target = globalThis as GlobalWithImportMetaEnv;
  const next: Partial<Record<SharedUiEnvKey, string>> = { ...(target.importMetaEnv ?? {}) };

  for (const key of SHARED_UI_ENV_KEYS) {
    const value = env[key];
    next[key] = typeof value === 'string' ? value : undefined;
  }

  target.importMetaEnv = next;
};
